import {Injectable} from '@angular/core';
import { map, Observable, tap} from 'rxjs';
import { ContractRoadmapModel, ContractStepModel } from '../../../models/contract.model';
import { HelpersService } from '../../../services/helpers.service';
import { ContractsService } from '../../../services/api/contracts.service';
import { AlertService } from '../../../services/notify/alert.service';
import { TranslateService } from '@ngx-translate/core';
import { ContractGetTargetDataService } from './contract-get-target-data.service';
import { IVerifiedRoadmap} from '../models/contract-internal-models';
import { ContractDataService } from './contract-data.service';
import { ContractLoadService } from './contract-load.service';

@Injectable({
    providedIn: 'root'
})
export class ContractRoadMapService {

  constructor(
    private contractsService:ContractsService,
    private contractLoadService:ContractLoadService,
    private helpersService:HelpersService,
    private alertService:AlertService,
    private translateService:TranslateService,
    private contractDataService:ContractDataService,
    private contractGetTargetDataService:ContractGetTargetDataService
  ) { }
  onRoadMapSave(contractRoadmap: ContractRoadmapModel, contractGuid:string, contractStatus:string ) {
		const roadmap: { roadmap: ContractStepModel[] } = {roadmap: []};
		const verifiedRoadmap: IVerifiedRoadmap [] = [];
		if (contractRoadmap.steps) {
			for (const element of contractRoadmap.steps) {
				element.target = element.target ? element.target : {};
				if (contractStatus === 'verified' && !element.target.guid && element.target_key) {
					verifiedRoadmap.push({
						step_guid: element.guid,
						target_key: element.target_key,
						target_type: element.target_type,
						contract_guid: contractGuid,
					});
					} else {
            element.multi_payment_data?.forEach(mp=> mp.payment_guid?.includes('new_payment')? delete mp.payment_guid  : null)
						roadmap.roadmap.push({
							deadline_at: element.deadline_at ? element.deadline_at : null,
							description: element.description ? element.description : null,
							guid: element.guid && element.guid.includes('Preview') === false ? element.guid : null,
							name: element.name,
							target: (element.target_type as any), // конфликт модели обьекта и модели эндпоинта
							target_key: element.payment_data ? null : element.target_key ? element.target_key : null,
							payment_data: element.payment_data ? element.payment_data : null,
							multi_payment_data: element.multi_payment_data ? element.multi_payment_data : [],
							sort_index: element.sort_index
						});
					}
			}
		}
		if (contractStatus === 'verified') {
			for (const element of verifiedRoadmap) {
				this.contractsService.fillStep(element).subscribe({
					next: res => this.roadMapSaveSuccess(res,contractGuid),
					error: error => this.roadMapSaveError(error)
				})
			}
		} else {
			this.contractsService.updateRoadMap(contractGuid, roadmap).subscribe({
				next: res =>this.roadMapSaveSuccess(res,contractGuid),
				error: (error:{message:string}) => this.roadMapSaveError(error)
			});
		}
  }
	roadMapSaveSuccess(res:{message:string},contractGuid:string|undefined) {
		this.alertService.setAlert(res.message,'nd_color')
		this.contractLoadService.onLoadingContract(contractGuid||'', true, false);
		this.contractDataService.subContractFormState.next('Default')
	}
	roadMapSaveError(error:{message:string}) {
		this.contractDataService.subContractFormState.next('Default')
		this.alertService.setAlert(error.message,'red')
	}
  getSubContract(guid:string, pointerCalc:boolean=false):Observable<ContractStepModel[]|[]> {
    return this.contractDataService.getContractByGuid(guid)
    .pipe(
        map(contract=>contract.roadmap_active.steps||[]),
        map(steps=>steps.map(el=>{return {...el,name:el.name||this.helpersService.defaultContractStepName(el)}})),
        tap(d=>pointerCalc? this.contractDataService.subStepPreviewPointerCalc.next(true) : null)
    )
  }
  onSaveStep(roadmap: ContractStepModel[],step:ContractStepModel, targetItem:any,contractGuid:string): void {
    console.log('targetItem',targetItem)
    
      let isVerified = false;
      let targetKey = null;
      let targetName = null;
      let message = '';
      
      switch (step.target_type) {
          case 'file':
              targetKey = targetItem.key;
              targetName = targetItem.name;
              isVerified = targetItem.signed;
              message = this.translateService.instant('ALERTS.FILE_ADDED');
              break;
          case 'task':
              targetKey = targetItem.task_alias;
              targetName = targetItem.title;
              isVerified = targetItem.status_current.is_successful;
              message = this.translateService.instant('ALERTS.TASK_ADDED');
              break;
          case 'sub_contract':
              targetKey = targetItem.guid;
              targetName = targetItem.name;
              isVerified = !!targetItem.comleted_at;
              message = this.translateService.instant('ALERTS.CONTRACT_ADDED');
              break;
      }
/*        if (roadmap.filter(step => step.target_key === targetKey).length) {
          return this.alertService.setAlert(message, 'blue');
      } */

      step.target_key = targetKey;
      step.targetName = targetName;
      step.deadline_at = null;
      step.description = null;
      step.target = {};
      step.target.is_verified = isVerified;

      this.contractDataService.subContractEdited.next(true);
      this.contractGetTargetDataService.getStepTargetData([step],this.contractDataService.currentMember?.guid!,contractGuid).subscribe();
  }
}